import { useState, useRef } from 'react';

export const useAccordionGroup = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const contentRefs = useRef<Map<number, HTMLDivElement>>(new Map());

  const setContentRef = (index: number) => (el: HTMLDivElement | null) => {
    if (el) {
      contentRefs.current.set(index, el);
    } else {
      contentRefs.current.delete(index);
    }
  };

  const toggle = (index: number) => {
    const prevIndex = openIndex;
    const nextIndex = prevIndex === index ? null : index;

    if (prevIndex !== null) {
      const prevEl = contentRefs.current.get(prevIndex);
      if (prevEl) {
        prevEl.style.display = 'none';
      }
    }

    if (nextIndex !== null) {
      const nextEl = contentRefs.current.get(nextIndex);
      if (nextEl) {
        nextEl.style.display = 'block';
      }
    }

    setOpenIndex(nextIndex);
  };

  return { openIndex, toggle, setContentRef };
};
